import { BreadcrumbDesignTokens } from '@primeuix/themes/types/breadcrumb';

export const breadcrumbPreset: BreadcrumbDesignTokens = {
  root: {
    background: 'none',
    padding: '0',
    gap: '0',
  },
  separator: {
    color: 'var(--gray-1)'
  }
};
